export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-thumb-fb694ba603b64f47d78a6eebc7ab6f37.png";